<template>
  <div class="wapper">
    <el-page-header @back="goBack"
                    content="发票内容详情"
                    class="header">
    </el-page-header>
    <div class="content-wapper"
         v-if="null != info">
      <span class="title">发票内容基础信息</span>
      <ul class="info-wapper">
        <li>
          <div>
            <label>发票内容编号</label>
            <span>{{info.id}}</span>
          </div>
          <div>
            <label>发票内容状态</label>
            <span>{{info.stateValue}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>渠道来源</label>
            <span>{{info.sourceValue}}</span>
          </div>
          <div>
            <label>发票内容名称</label>
            <span>{{info.name}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>税率</label>
            <span>{{info.taxRateString}}</span>
          </div>
          <div>
            <label>创建人</label>
            <span>{{info.creatorName}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>创建时间</label>
            <span>{{info.gmtCreate}}</span>
          </div>
          <div>
            <label>最后编辑人</label>
            <span>{{info.operatorName}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>最后修改时间</label>
            <span>{{info.gmtModified}}</span>
          </div>
          <div>
            <label>备注</label>
            <span>{{info.remarks}}</span>
          </div>
        </li>
      </ul>
      <div class="images-wapper">
        <span class="title">关联税收分类信息</span>
        <ul class="info-wapper">
          <li>
            <div>
              <label>税收分类编码</label>
              <span>{{info.categoryCode}}</span>
            </div>
            <div>
              <label>税收分类名称</label>
              <span>{{info.categoryName}}</span>
            </div>
          </li>
          <li>
            <div>
              <label>税收分类简称</label>
              <span>{{info.categoryAbbr}}</span>
            </div>
            <div>
              <label>关联操作人</label>
              <span>{{info.relatedName}}</span>
            </div>
          </li>
          <li>
            <div>
              <label>最后关联操作时间</label>
              <span>{{info.relatedTime}}</span>
            </div>

          </li>
          <li>
            <div>
              <label>说明</label>
              <span>{{info.categoryRemarks}}</span>
            </div>

          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import _invoiceContent from '@/service/invoice-content-service'

export default {
  data () {
    return {
      id: this.$route.query.id,
      info: null,
    }
  },
  mounted () {
    // 查询信息
    let _loading = this.$loading({ fullscreen: true })
    _invoiceContent.getInvoiceDetail(this.id, response => {
      _loading.close()
      this.info = response
    })
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.wapper {
  padding: 15px;
}
.header {
  margin-bottom: 15px;
}
.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 30px;
  padding-top: 15px;
  background: #fff;
}
.title {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 30px 0 10px 0;
}
.info-wapper li {
  margin: 15px 0;
}
.info-wapper div {
  display: inline-block;
  width: 400px;
  position: relative;
}
.info-wapper .special {
  width: 800px;
}
.info-wapper span {
  margin-left: 130px;
  display: inline-block;
  vertical-align: top;
}
.info-wapper label {
  color: #909399;
  display: inline-block;
  width: 100px;
  text-align: right;
  position: absolute;
  top: 0;
}
.textarea {
  display: inline-block;
  width: 500px;
}
.images-wapper {
  border-top: 1px dashed #909399;
  margin-top: 30px;
}
.info-wapper .el-image {
  width: 210px;
  height: 100px;
  border-radius: 6px;
  margin-left: 15px;
}
.table-wapper {
  margin-left: 130px;
  width: 550px;
}
.table-wapper label {
  padding: 10px 0;
  text-align: center;
  width: 100%;
  display: block;
  font-weight: bold;
  border: 1px solid #d6dbe5;
  border-bottom: none;
}
.table-wapper table {
  border: 1px solid #d6dbe5;
  width: 100%;
}
.table-wapper td {
  padding: 10px;
  border-bottom: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
}
.table-wapper tr:first-child td {
  font-weight: bold;
  background: #f9f9f9;
}
</style>